﻿// Write your JavaScript code.
import 'normalize.css/normalize.css'
import '../Styles/main.scss';
import Choices from "choices.js";
import $ from "jquery";

function init() {
    // Modify forms to disable all buttons on submit

    function disableButtonsAndInputs(form) {
        form.querySelectorAll('button, input[type=submit]').forEach(e => {
            e.disabled = true;
        });
    }

    document.querySelectorAll('form').forEach(e => {
        e.addEventListener('submit', (evt) => {
            disableButtonsAndInputs(evt.target);
        });
    });

    // Enable show password button
    const passwordIcon = document.getElementById('password-icon');
    const passwordInput = document.getElementById('password-input');
    if (passwordIcon && passwordInput) {
        passwordIcon.addEventListener('mousedown', function (event) {
            passwordInput.type = 'text';
        });
        passwordIcon.addEventListener('mouseup', function (event) {
            passwordInput.type = 'password';
        });
        passwordIcon.addEventListener('touchstart', function () {
            passwordInput.type = 'text';
        });
        passwordIcon.addEventListener('touchend', function () {
            passwordInput.type = 'password';
        });
    }

    // Begin of change school (impersonation) page logic.
    const selectClass = document.getElementById('select-class');

    if (selectClass){
        let trial = false;
        let regularSchools;
        let trialSchools;
        let currentSchoolId;

        const submitButton = document.getElementById('submit-button');
        const showTrialButton = document.getElementById('show-trial-schools');
        const currentClassIdInput = document.getElementById('current-class-id');

        let currentClassId = currentClassIdInput.value;

        const selectSchool = $('#school-select');
        const selectSchoolDropdown = setupDropdown(selectSchool);
        selectSchoolDropdown.passedElement.element.addEventListener(
            'addItem',
            function(event) {
                currentSchoolId = event.detail.value;
                updateClassesDropdown();
            },
            false,
        );

        const selectClass = $('#class-select');
        const selectClassDropdown = setupDropdown(selectClass);
        selectClassDropdown.passedElement.element.addEventListener(
            'addItem',
            function (event){
                currentClassId = event.detail.value;
                currentClassIdInput.value = currentClassId;
            }
        )

        getSchools();

        // Handles the updating of the dropdowns when the checkbox is toggled.
        function toggleTrial(){
            if (trialSchools){
                trial = !trial;
                showTrialButton.checked = trial;

                let schoolsForDropdown = (trial ? trialSchools : regularSchools);
                updateSchoolsDropdown(schoolsForDropdown);
            }
        }

        // Update the schools dropdown and call the update for the classes dropdown as well.
        function updateSchoolsDropdown(schools){
            const mappedSchools = schools.map(s => {
                const label = s.brinCode ?
                    `${s.name} (id: ${s.schoolId} - brin: ${s.brinCode})`
                    : `${s.name} (id: ${s.schoolId})`;

                return {
                    label: label,
                    value: s.schoolId
                };
            });

            // Just 're'-setting the choices bugs the search box for some reason. You have to clear the store to
            // reset the entire thing, and then you can set the new choices.
            selectSchoolDropdown.clearStore();
            selectSchoolDropdown.setChoices(mappedSchools, 'value', 'label', true,
                true, true);

            currentSchoolId = schools.find(s => s.schoolId === currentSchoolId)?.schoolId;
            if (!currentSchoolId) {
                currentSchoolId = schools[0].schoolId;
            }

            selectSchoolDropdown.setChoiceByValue(currentSchoolId);

            updateClassesDropdown();
        }

        // Update the classes dropdown and the value of the selected class.
        function updateClassesDropdown(){
            const classes = (trial ? trialSchools : regularSchools)
                .find(s => s.schoolId === currentSchoolId)?.classes;

            if (classes){
                const mappedClasses = classes.map(c => ({
                    label: c.name,
                    value: c.classId
                }));

                // Just 're'-setting the choices bugs the search box for some reason. You have to clear the store to
                // reset the entire thing, and then you can set the new choices.
                selectClassDropdown.clearStore();
                selectClassDropdown.setChoices(mappedClasses, 'value', 'label', true,
                    true, true);

                currentClassId = classes.find(c => c.classId === currentClassId)?.classId;
                if (!currentClassId) {
                    currentClassId = classes[0].classId;
                }

                selectClassDropdown.setChoiceByValue(currentClassId);

                currentClassIdInput.value = currentClassId;
            }
        }

        // Fetch from controller. Used for initial load.
        function getSchools(){
            $.ajax({
                url: '/changeSchool/getAvailableSchools',
                type: 'GET',
                data: {
                    currentClassId: currentClassId,
                }
            }).then(response => {
                regularSchools = response.regularSchools;
                trialSchools = response.trialSchools;
                currentSchoolId = response.currentSchoolId;
                currentClassId = response.currentClassId;

                if (response.canSeeTrialSchools){
                    showTrialButton.addEventListener('click', toggleTrial);
                    showTrialButton.disabled = false;

                    // Correctly set the toggle and the dropdowns if the impersonated school is a trial school.
                    if (isCurrentSchoolTrial(response.canSeeTrialSchools)){
                        toggleTrial();
                    } else {
                        updateSchoolsDropdown(regularSchools);
                    }
                } else {
                    updateSchoolsDropdown(regularSchools);
                }


                submitButton.disabled = false;
            });
        }

        function isCurrentSchoolTrial(canSeeTrial){
            if (!canSeeTrial){
                return false;
            }

            return trialSchools.filter(s => s.schoolId === currentSchoolId).length > 0;
        }

        // Returns a preconfigured dropdown. Requires a JQuery element.
        function setupDropdown(element){
            const dropdown = new Choices(element[0], {
                shouldSort: false,
                searchResultLimit: -1,
                searchFields: ['label'],
                noResultsText: 'No results found',
                fuseOptions: {
                    ignoreLocation: true,
                    ignoreDiacritics: true,
                    threshold: 0,
                    ignoreFieldNorm: true
                }
            });

            dropdown.passedElement.element.addEventListener(
                'showDropdown',
                () => {
                    dropdown.clearInput();
                    element.parent().parent().find('.is-selected')[0].scrollIntoView({ block: 'center' });
                })

            return dropdown;
        }
    }
    // End of change school (impersonation) page logic.
}

(function() {
	window.addEventListener('DOMContentLoaded', init);
})();
